module.exports = __webpack_public_path__ + "img/j.38c260ef.svg";